import { JSX, ReactElement, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { IPageNavSection } from "../../Layout/PageNav/PageNav";
import { Typography } from "../../Typography/Typography/Typography";
import { Guid } from "@iconics/core";
import { GridContainer } from "../../Layout/Grid/GridContainer";
import { GridItem } from "../../Layout/Grid/GridItem";
import "./Styles.scss";

export class Card extends BaseComponent<ICardProps, ICardState>
{
    private sectionId = Guid.new().toString();

    public componentDidMount(): void
    {
        this.props.onSectionUpdate?.({
            id: this.sectionId,
            index: -1,
            name: this.props.title,
        });
    }

    public componentWillUnmount(): void
    {
        this.props.onSectionUpdate?.(this.sectionId);
    }

    public render(): JSX.Element
    {
        return (
            <GridContainer
                spacing="none"
                className='card'
            >
                <GridItem
                    compact={12}
                    id={`${this.sectionId}`}
                    className='card__section'
                />
                <GridItem
                    compact={12}
                    className='card__icon-title'
                >
                    <GridContainer
                        spacing="xs"
                        style={this.props.actions ? { flexWrap: 'nowrap', alignItems: 'center' } : {}}
                    >
                        {
                            this.props.icon &&
                            <GridItem
                                compact='auto'
                                className='card__icon'
                            >
                                {this.props.icon}
                            </GridItem>
                        }
                        <GridItem
                            compact='auto'
                            className='card__title'
                            style={this.props.actions ? { flexGrow: 1 } : {}}
                        >
                            <Typography variant='h2' role='title' size='medium' >
                                {this.props.title}
                            </Typography>
                        </GridItem>
                        {
                            this.props.actions &&
                            <GridItem
                                compact='auto'
                            >
                                {this.props.actions}
                            </GridItem>
                        }
                    </GridContainer>
                </GridItem>
                {
                    this.props.subTitle &&
                    <GridItem
                        compact={12}
                        className='card__sub-title'
                    >
                        <Typography role='body' size='medium'>
                            {this.props.subTitle}
                        </Typography>
                    </GridItem>
                }
                {
                    this.props.details &&
                    <GridItem
                        compact={12}
                        className='card__details'
                    >
                        <Typography role='body' size='small'>
                            {this.props.details}
                        </Typography>
                    </GridItem>
                }
                <GridItem
                    compact={12}
                    className='card__content'
                >
                    {this.props.children}
                </GridItem>
            </GridContainer>
        );
    }
}

export interface ICardProps
{
    icon?: ReactElement;
    title: string;
    actions?: ReactNode;
    subTitle?: string;
    details?: string;
    children: ReactNode;
    onSectionUpdate?: OnSectionUpdateHandler;
}

export interface ICardState { }
export type OnSectionUpdateHandler = (sectionOrId: IPageNavSection | string) => void;
